import { render, staticRenderFns } from "./DashboardPlanSummary.vue?vue&type=template&id=1bc775d2&scoped=true&"
import script from "./DashboardPlanSummary.vue?vue&type=script&lang=js&"
export * from "./DashboardPlanSummary.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPlanSummary.vue?vue&type=style&index=0&id=1bc775d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc775d2",
  null
  
)

export default component.exports